import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

import { Amplitude } from '@/amplitude';
import { App } from '@/app/App';
import '@/shared/i18n';

import './styles/antd-override.css';
import './styles/cascader-overrides.css';
import './styles/index.css';
import './styles/panda.css';

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <Amplitude />
    <App />
  </StrictMode>,
);
